/**
 * @generated SignedSource<<a76e83465d8112330ebf499f641c2363>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerAssociations_seller$data = {
  readonly tradeAssociations: ReadonlyArray<{
    readonly displayName: string | null;
    readonly serviceId: string | null;
  } | null> | null;
  readonly " $fragmentType": "PdpSharedSellerAssociations_seller";
};
export type PdpSharedSellerAssociations_seller$key = {
  readonly " $data"?: PdpSharedSellerAssociations_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerAssociations_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerAssociations_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeAssociation",
      "kind": "LinkedField",
      "name": "tradeAssociations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "4dc8139a00d6fa19a1214062c06ac067";

export default node;
